import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseDeleteEstablishmentCompanyMaintenanceSpecialtyProps {
  establishmentCompanyId?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useDeleteEstablishmentCompanyMaintenanceSpecialty = ({
  establishmentCompanyId,
  onSuccess,
  onError,
}: UseDeleteEstablishmentCompanyMaintenanceSpecialtyProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['deleteEstablishmentCompanyMaintenanceSpecialty', establishmentCompanyId],
    mutationFn: (maintenanceSpecialtyId: string) => {
      const payload = {
        maintenance_specialty_attributes: {
          id: maintenanceSpecialtyId,
          _destroy: true,
        },
      }

      return privateAxios.put(`/establishment/companies/${establishmentCompanyId}/update_maintenance_models`, {
        company: payload,
      });
    },
    onSuccess,
    onError,
  });
}
